module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-1.b2332ac9.jpeg";